<template>
  <div>
    <b-row>
      <b-col
          md="12"
          sm="12"
      >
        <b-row class="mb-1">

          <b-col :cols="isMobile ? 12 : 1">

            <b-button
                variant="danger"
                class="btn-block btn-sm"
                @click="LastDay"
            >
              Letzer
            </b-button>
          </b-col>

          <b-col cols="2" style="font-size: large">
            Tag: {{
              `${new Date(this.$route.params.day).toLocaleString('de-DE', {
                    weekday: 'long',
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit'
                  },
              )}`
            }}
          </b-col>

          <b-col cols="5"
          >
          </b-col>
          <b-col cols="1" v-show="!isMobile">
            <b-button @click="OpenPdf"
                      class="btn-block btn-sm"
            >Pdf
            </b-button>
          </b-col>
          <b-col :cols="isMobile ? 12 : 2">
            <b-button
                variant="info"
                class="btn-block btn-sm"
                @click="DispositionDispatch"
            >
              Dispo versenden
            </b-button>
          </b-col>
          <b-col :cols="isMobile ? 12 : 1">

            <b-button
                variant="danger"
                class="btn-block btn-sm"
                @click="NextDay"
            >
              Nächster
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-badge
                v-show="!isMobile"
                v-for="dl in headerDrivers"
                class="mt-1 mr-1"
                @click="FilterDriver(dl.Driver.DId)"
                :variant="dl.TripCount > 0 ? 'warning' : dl.Variant"
            >{{ dl.Driver.DriverShortName }} {{ dl.Calendar }}
            </b-badge>
          </b-col>

          <b-col :cols="isMobile ? 12 : 3" :class="isMobile ? 'mb-1 mt-1' : ''">
            <b-form-select
                id="perPageSelect"
                v-model="filterCustomer"
                size="xl"
                :options="filterCustomerOptions"
                class="w-100"
            />
          </b-col>
          <b-col :cols="isMobile ? 12 : 3" :class="isMobile ? 'mb-1 mt-1' : ''">
            <b-form-select
                id="perPageSelect"
                v-model="filterAddress"
                size="xl"
                :options="filterAddressOptions"
                class="w-100"
            />
          </b-col>

        </b-row>
      </b-col>
      <b-col cols="12" v-show="isMobile">
        <b-form-group
            label="Fahrer"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-2"
            name="name"
        >
          <b-form-select
              id="perPageSelect"
              v-model="DriverFilter"
              size="xl"
              :options="this.filterDrivers"
              class="mb-2"
              @change="FilterDriver"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" class="mt-2 scrollable">
        <div
            v-for="item in items"
            :key="item.Vid"
            v-show="CheckFilter(item)"
            v-bind:style="Background(item)"
        >
          <b-row v-show="item.Canceled">
            <b-col cols="12">
              <b-badge
                  variant="warning"
              >
                Storniert
              </b-badge>
            </b-col>
          </b-row>
          <b-row>
            <b-col :cols="isMobile ? 6 : 1">
              <b-row style="font-weight: bold; margin-left: 0.2em; font-size: 1.10em" :id="'pwtVD'+item.Vid" @click="OpenVehicleDistance(item.Vid)">{{ FormatTime(item.PickupTime) }}

                <b-badge
                    v-if="item.Flight != null && item.Flight.ScheduledTimeCorrected != FormatTime(item.PickupTime)"

                    v-show="item.Flight.ScheduledTimeCorrected != null"
                    class="ml-1 bg-danger bg-darken-4"
                >
                  {{ item.Flight.ScheduledTimeCorrected }}
                </b-badge>
                <b-badge
                    v-if="item.Flight != null && item.Flight.IsCanceled != null"
                    variant="danger"
                    v-show="item.Flight.IsCanceled"
                    class="ml-1"
                >Annulliert
                </b-badge>
              </b-row>
              <b-row
                  :id="'pwtV'+item.Vid"
                  @click="OpenWorkTime(item.Vid, parseInt(item.TripRouteCorrection.TripFullDuration / 60))"
                  style="margin-left: 0.2em;"
                  v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                  v-b-tooltip.hover.v-info
                  :title="parseInt(item.TripRoute.TripFullDuration / 60)+'min'+ (item.TripRouteCorrection.TripFullDuration > 0 ? ' / '+parseInt(item.TripRouteCorrection.TripFullDuration / 60)+'min' : '')"
                  variant="outline-info"
              >{{ parseInt(item.TripRoute.TripDuration / 60) }}min
              </b-row>
              <b-row style="margin-left: 0.2em;">{{ parseInt(item.TripRoute.TripDistanceMeter / 1000) }}km</b-row>
            </b-col>
            <b-col :cols="isMobile ? 6 : 2" :class="isMobile ? 'mb-1':''">
              <b-row style="cursor: pointer">
                <b-dropdown
                    class="float-right"
                    size="sm"
                    v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                    variant="flat-dark"
                    right
                    :text="'V-ID: ' + item.Vid"
                >
                  <b-dropdown-item
                      variant="warning"
                      @click="OpenVoucher(item.Vid)"
                  >
                    Bearbeiten
                  </b-dropdown-item>
                  <b-dropdown-item
                      v-show="!item.Confirmed"
                      variant="success"
                      @click="ConfirmVoucher(item)"
                  >Bestätigen
                  </b-dropdown-item>
                  <b-dropdown-divider/>
                  <b-dropdown-item
                      variant="danger"
                      @click="Cancel(item)"
                      v-show="!item.Canceled"
                  >Stornieren
                  </b-dropdown-item>
                  <b-dropdown-item
                      variant="danger"
                      @click="UndoCancel(item)"
                      v-show="item.Canceled"
                  >Entstornieren
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
              <b-row v-show="item.RideType == 1">Transportschein: {{ (item.MedicalTrip.TransportTicket ? 'Ja' : 'Nein') }}</b-row>
              <b-row v-show="item.RideType == 1">Termin: {{ (item.MedicalTrip.AppointmentTime) }} Uhr</b-row>
              <b-row v-show="item.RideType == 2">Wunsch Ank.: {{ (item.Flight.ScheduledTime) }} Uhr</b-row>
              <b-row v-show="item.RideType == 0">Flug: {{ item.Flight.Iata }} ({{ item.Flight.ScheduledTime }})
                <b-badge
                    variant="light-warning"
                    v-show="item.Flight.ExpectedTime != null"
                    class="ml-1"
                >
                  {{ item.Flight.ExpectedTime }}
                </b-badge>
              </b-row>
              <b-row v-show="item.RideType == 0">{{ item.Flight.Departure }} ==> {{ item.Flight.Arrivals }}</b-row>
            </b-col>
            <b-col :cols="isMobile ? 12 : 3">
              <b-row :class="isMobile ? 'p-1' : ''">
                <b-col
                    md="7"
                    xl="7"
                    :class="isMobile ? 'mb-1 p-1' : 'mb-1'"
                >
                  <b-row>{{ item.PickUpAddress.Name }}</b-row>
                  <b-row>{{ item.PickUpAddress.Street }}</b-row>
                  <b-row>{{ item.PickUpAddress.ZipCode }} {{ item.PickUpAddress.Location }}
                    {{ item.PickUpAddress.District }}
                  </b-row>
                </b-col>
                <b-col
                    md="5"
                    xl="5"
                    class="mb-1"
                >

                  <b-row :class="isMobile ? 'font-weight-bold' : ''">Tel.:&emsp;<a style="color: aliceblue; cursor:pointer" @click.prevent="CallNumber(item.PickUpAddress.Phone)">{{ item.PickUpAddress.Phone}}</a></b-row>
                  <br v-show="isMobile">
                  <b-row :class="isMobile ? 'font-weight-bold' : ''" v-show="item.PickUpAddress.Phone2 != ''"><a style="color: aliceblue; cursor:pointer" @click.prevent="CallNumber(item.PickUpAddress.Phone2)">{{ item.PickUpAddress.Phone2}}</a></b-row>
                  <br v-show="isMobile">
                </b-col>
              </b-row>
            </b-col>
            <b-col :cols="isMobile ? 12 : 3" style="font-weight: bold;">
              <b-row>
                <b-col
                    md="7"
                    xl="7"
                    class="mb-1"
                >

                  <b-row :class="isMobile ? 'float-right text-right mr-1' : ''">{{ item.DestinationAddress.Name }}<br></b-row>
                  <br v-show="isMobile">
                  <b-row :class="isMobile ? 'float-right text-right mr-1' : ''">{{ item.DestinationAddress.Street }}<br></b-row>
                  <br v-show="isMobile">
                  <b-row :class="isMobile ? 'float-right text-right mr-1' : ''">{{ item.DestinationAddress.ZipCode }} {{ item.DestinationAddress.Location }}
                    {{ item.DestinationAddress.District }}
                  </b-row>
                  <br v-show="isMobile">
                </b-col>
                <b-col
                    md="5"
                    xl="5"
                    class="mb-1"
                >

                  <b-row :class="isMobile ? 'float-right text-right mr-1 font-weight-bold' : ''">Tel.:&emsp;<a style="color: aliceblue; cursor:pointer" @click.prevent="CallNumber(item.DestinationAddress.Phone)"> {{ item.DestinationAddress.Phone }}</a></b-row>
                  <br v-show="isMobile">
                  <b-row :class="isMobile ? 'float-right text-right mr-1 font-weight-bold' : ''" v-show="item.DestinationAddress.Phone2 != ''"><a style="color: aliceblue; cursor:pointer" @click.prevent="CallNumber(item.DestinationAddress.Phone2)"> {{ item.DestinationAddress.Phone2}}</a></b-row>
                  <br v-show="isMobile">
                </b-col>
              </b-row>
            </b-col>
            <b-col :cols="isMobile ? 12 : 1" :class="isMobile ? 'center-layout ml-1' : 'center-layout'">
              <b-row>
                <div v-show="isMobile">Fahrgäste:&ensp;</div>
                {{ item.Passenger.Passengers }} - {{ item.Passenger.PassengersChildren }}
              </b-row>
            </b-col>
            <b-col :cols="isMobile ? 12 : 2">
              <b-row>
                <b-row :class="isMobile ? 'p-1' : ''">
                  <b-col cols="12">
                    <b-badge
                        class="mb-1 float-right"
                        v-show="item.PaymentDriver != ''"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        v-b-tooltip.hover.v-primary
                        variant="warning"
                        v-bind:style="{ width: '100%'}"
                    >Bereits kassiert!
                    </b-badge>
                  </b-col>
                </b-row>
              </b-row>
              <b-row :class="isMobile ? 'p-1' : ''">
                <b-col cols="8">
                  <b-row v-for="d in item.Driver">
                    <b-badge
                        class="mb-1"
                        v-bind:style="{color: d.Color2, background: d.Color1, width: '100%'}"
                        @dblclick="SelectDriver(item.Driver, item.Vid, d)"
                    >{{ d.title }}
                    </b-badge>
                  </b-row>
                </b-col>

                <b-col cols="4">
                  <b-dropdown
                      class="float-right"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="flat-dark"
                      right
                  >
                    <b-dropdown-item
                        v-for="dl in drivers"
                        @click="SelectDriver(item.Driver, item.Vid, dl)"
                        :style="'background-color: ' + dl.Color1 + ';'"
                    >
                      <div :style="'color: ' + dl.Color2">{{ dl.title }}</div>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col :cols="isMobile ? 12 : 8">
              <b-form-group>
                <label class="d-inline-block text-sm-left mr-50">Zeile Lang (Intern)</label>
                <b-form-input v-model="Description[item.Vid].Description2" @keyup="SaveDescription($event, item)"/>
              </b-form-group>
            </b-col>
            <b-col :cols="isMobile ? 12 : 4">

              <b-form-group>
                <label class="d-inline-block text-sm-left mr-50">Zeile Kurz</label>
                <b-form-input v-model="Description[item.Vid].Description1" @keyup="SaveDescription($event, item)"/>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col :cols="isMobile ? 12 : 8">

              <b-button
                  :class="isMobile ? 'btn-block mb-1' : 'mr-1'"
                  v-show="!item.Confirmed"
                  size="sm"
                  v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                  variant="danger"
                  right
              >
                Kontrolle fehlt
              </b-button>

              <b-button
                  :class="isMobile ? 'btn-block mb-1' : 'mr-1'"
                  v-show="item.Price.PaymentMethod == 1 && item.Price.PriceFull > 0"
                  size="sm"
                  v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                  variant="outline-warning"
                  right
              >
                Rechnung {{ FormatEuro(item.Price.PriceFull) }}
              </b-button>
              <b-button
                  :class="isMobile ? 'btn-block mb-1' : 'mr-1'"
                  v-show="item.Price.PaymentMethod == 2 && item.Price.PriceFull > 0"
                  size="sm"
                  v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                  variant="outline-warning"
                  right
              >
                Lastschrift {{ FormatEuro(item.Price.PriceFull) }}
              </b-button>
              <b-dropdown
                  :class="isMobile ? 'btn-block mb-1' : 'mr-1'"
                  v-show="item.Price.PaymentMethod == 3 && item.Price.PriceFull > 0"
                  size="sm"
                  v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                  :variant="item.PaymentDriver != '' ? 'outline-success' : 'outline-info'"
                  right
                  :text="'Barzahlung / EC: ' + FormatEuro(item.Price.PriceFull) + ' ('+item.PaymentDriver+')'"
              >
                <b-dropdown-item
                    v-for="dl in drivers"
                    @click="SelectDriverPayment(dl.driverId, item.Vid)"
                >
                  {{ dl.title }}
                </b-dropdown-item>
                <b-dropdown-item
                    v-show="item.PaymentDriver != ''"
                    v-for="dl in drivers"
                    @click="SelectDriverPayment(0, item.Vid)"
                >
                  Fahrer entfernen
                </b-dropdown-item>
              </b-dropdown>

            </b-col>
            <b-col :cols="isMobile ? 12 : 4">
              <feather-icon
                  v-show="item.TempCheckTime == null && HasBetaRights()"
                  icon="SquareIcon"
                  size="21"
                  @click="TempCheck(item.Vid)"
                  style="cursor: pointer"
              />
              <feather-icon
                  v-show="item.TempCheckTime != null && HasBetaRights()"
                  icon="CheckSquareIcon"
                  size="21"
                  @click="TempCheck(item.Vid)"
                  style="cursor: pointer"
              />
              <b-badge class="float-right ml-1" variant="info" v-show="item.Customer.CustomerType == 1">Crew</b-badge>
              <b-badge class="float-right ml-1" variant="success" v-show="item.Customer.CustomerType == 2">Reisebüro</b-badge>
              <b-badge class="float-right" style="background-color: #480081; box-shadow: 0 0 9px rgba(78,24,178,0.5);">({{ item.Customer.CustomerNumber }}) {{ item.Customer.Name }}</b-badge>

              <connected-voucher-badge v-bind:vData="item.ConnectedVoucher"/>
              <b-badge
                  class="ml-1 mt-2 float-right" style="color: #e8e8e8; background: #007b8d; cursor: pointer;"
                  @click="$root.$emit('OpenNoteMenu', 'voucher'+item.Vid)"
              >
                Notiz
              </b-badge>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-popover
        ref="popoverWorkTime"
        :target="'pwtV'+popover.WorkTime.popoverId"
        :show.sync="popover.WorkTime.popoverShow"
        :disabled.sync="popover.WorkTime.popoverDisabled"
        placement="bottom"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Korektur</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
                @click="CloseWorkTime"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-input-group>
          <b-form-input
              v-model="popover.WorkTime.data.Field"
              class="form-control form-control-sm"
              placeholder="0"
              tabindex="28"
          />
          <template #append>
            <b-button
                variant="success"
                @click="SaveWorkTime()"
                size="sm"
            >
              <feather-icon
                  size="14"
                  icon="SaveIcon"
                  class="mr-50"
              />
            </b-button>
          </template>
        </b-input-group>
      </div>
    </b-popover>

    <b-popover
        ref="popoverVehicleDistance"
        :target="'pwtVD'+popover.VehicleDistance.popoverId"
        :show.sync="popover.VehicleDistance.popoverShow"
        :disabled.sync="popover.VehicleDistance.popoverDisabled"
        placement="bottom"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Fahrzeuge</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
                @click="CloseVehicleDistance"
            >&times;</span>
          </b-button>

        </div>
      </template>

      <div>

        <div v-for="d in popover.VehicleDistance.data.list">
          <b-badge :variant="popover.VehicleDistance.data == true ? 'success' : 'warning'" style="width: 100%" class="mb-1"> {{ d.veh.NumberPlate }} - {{ (d.here.distance / 1000).toFixed(0) }}km ({{ (d.here.trafficTime / 60).toFixed(0) }}min)</b-badge>
        </div>
      </div>
    </b-popover>
  </div>

</template>

<script>

import BCardCode from '@core/components/b-card-code'

import {
  BRow,
  BCol,
  BFormSelect,
  BFormInput,
  BButton,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BBadge,
  BPopover,
  BInputGroupPrepend,
  BInputGroupAppend,
  VBTooltip,
  BInputGroup,
  BFormGroup, BLink, BPagination,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ConnectedVoucherBadge from '@/views/extras/ConnectedVoucherBadge.vue'

export default {
  components: {
    BPagination,
    BLink,
    BCardCode,
    ConnectedVoucherBadge,
    vSelect,
    BRow,
    BCol,
    BFormSelect,
    BFormInput,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    BBadge,
    BPopover,
    BInputGroupPrepend,
    BInputGroupAppend,
    VBTooltip,
    BInputGroup,
    BFormGroup,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  sockets: {
    updateDispoVoucher(data) {
      let arr2 = Array.from(this.items)
      console.log('arr2')
      console.log(arr2)
      arr2.forEach((value, index) => {
        if (value.Vid == data.Vid) {
          this.items.splice(index, 1)
          console.log(data)
          let draw = this.VoucherDraw(data, index)
          console.log(draw)
          this.items.splice(index, 0, draw)
        }
      })
    },
  },
  data() {
    return {
      popover: {
        WorkTime: {
          popoverShow: false,
          popoverDisabled: false,
          popoverId: 0,
          data: {
            Field: 0,
            Vid: 0
          },
        },
        VehicleDistance: {
          popoverShow: false,
          popoverDisabled: false,
          popoverId: 0,
          data: {
            list: [],
            drivers: []
          }
        }
      },
      icon: {
        Fly: require('@/assets/images/dispo/flugzeug.png'),
        MedicalTrip: require('@/assets/images/dispo/krankenwagen.png'),
        Transfer: require('@/assets/images/dispo/taxi.png'),
        Airport: require('@/assets/images/dispo/airport.jpg'),
        Condor: require('@/assets/images/dispo/condor1.png'),
      },
      drivers: [],
      headerDrivers: [],
      filterDrivers: [],
      vehicleList: [],
      items: [],
      SaveDescriptionTimeout: null,
      DriverFilter: 0,
      TempCheckFilter: 0,
      isMobile: 0,
      filterCustomerOptions: [],
      filterCustomer: 0,
      filterAddressOptions: [],
      filterAddress: '',
      Description: [],
    }
  },
  created() {
    this.$nextTick(() => {
      let fd = `${new Date(this.$route.params.day).toLocaleString('de-DE', {
            month: '2-digit',
            day: '2-digit',
            weekday: 'short',
          },
      )}`
      document.title = 'D. ' + fd
    })
  },
  mounted() {
    this.CheckMobile()
    this.LoadVehicleList()
    this.LoadDriverList()
    this.LoadObCalendar()

  },
  beforeDestroy() {
    this.drivers = null
  },
  methods: {
    ReloadFilterCustomer() {
      this.filterCustomerOptions = []
      this.filterCustomerOptions.push({
        text: 'Keine Filterung',
        value: 0
      })
    },
    ReloadFilterAddress() {
      this.filterAddressOptions = []
      this.filterAddressOptions.push({
        text: 'Keine Filterung',
        value: 0
      })

      let filter = "";


      filter = "[Condor] HTL => LEJ"
      this.filterAddressOptions.push({
        text: filter,
        value: "19-1"
      })
      filter = "[Condor] LEJ => HTL"
      this.filterAddressOptions.push({
        text: filter,
        value: "1-19"
      })
      filter = "[Condor] HBF => LEJ"
      this.filterAddressOptions.push({
        text: filter,
        value: "107-1"
      })
      filter = "[Condor] LEJ => HBF"
      this.filterAddressOptions.push({
        text: filter,
        value: "1-107"
      })

      filter = "[Condor] HTL => ZHZ"
      this.filterAddressOptions.push({
        text: filter,
        value: "19-1064"
      })

      filter = "[Condor] ZHZ => HTL"
      this.filterAddressOptions.push({
        text: filter,
        value: "1064-19"
      })

      filter = "[Condor] LEJ => ZHZ"
      this.filterAddressOptions.push({
        text: filter,
        value: "1-1064"
      })

      filter = "[Condor] ZHZ => LEJ"
      this.filterAddressOptions.push({
        text: filter,
        value: "1064-1"
      })
      filter = "[CityLine] HTL => LEJ"
      this.filterAddressOptions.push({
        text: filter,
        value: "25-1"
      })
      filter = "[CityLine] LEJ => HTL"
      this.filterAddressOptions.push({
        text: filter,
        value: "1-25"
      })

      filter = "[LH] HTL => LEJ"
      this.filterAddressOptions.push({
        text: filter,
        value: "15-1"
      })
      filter = "[LH] LEJ => HTL"
      this.filterAddressOptions.push({
        text: filter,
        value: "1-15"
      })
    },
    OpenWorkTime(id, currentTime) {
      this.CloseWorkTime()
      this.$nextTick(() => {
        this.popover.WorkTime.data.Vid = id
        this.popover.WorkTime.popoverId = id
        this.popover.WorkTime.data.Field = currentTime

        this.$nextTick(() => {
          this.popover.WorkTime.popoverDisabled = false
          this.popover.WorkTime.popoverShow = true
        })
      })
    },
    CloseWorkTime() {
      this.popover.WorkTime.popoverDisabled = false
      this.popover.WorkTime.popoverShow = false
    },
    OpenVehicleDistance(id) {
      this.CloseVehicleDistance()
      this.$nextTick(() => {
        this.popover.VehicleDistance.popoverId = id
        this.items.forEach(i => {
          if (i.Vid == id) {
            this.popover.VehicleDistance.data.drivers = i.Drivers
          }
        })

        this.$http.get(`/voucher/get/vehicle/distance?vid=${id}`)
            .then(resp => {
              this.popover.VehicleDistance.data.list = []
              resp.data.list.forEach(i => {
                this.popover.VehicleDistance.data.list.push(i)
              })

            })
            .catch(err => {
              console.error(err)
            })

        this.$nextTick(() => {
          this.popover.VehicleDistance.popoverDisabled = false
          this.popover.VehicleDistance.popoverShow = true

        })
      })
    },
    CloseVehicleDistance() {
      this.popover.VehicleDistance.popoverDisabled = false
      this.popover.VehicleDistance.popoverShow = false
    },
    TempCheck(vid) {
      this.$http.get(`/disposition/temp/check/${vid}`)
          .then(resp => {
          })
          .catch(err => {
            console.error(err)
          })
    },
    SaveWorkTime() {
      this.$http.post('/disposition/save/voucher/work/time', JSON.stringify({
        Minutes: this.popover.WorkTime.data.Field,
        VoucherId: this.popover.WorkTime.data.Vid
      }))
          .then(resp => {
            if (resp.data.success) {
              this.items.forEach((v, i) => {
                if (v.Vid == this.popover.WorkTime.data.Vid) {
                  this.items[i].TripRouteCorrection.TripFullDuration = this.popover.WorkTime.data.Field * 60
                }
              })

              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Ok',
                      icon: 'CheckIcon',
                      text: 'V-ID ' + this.popover.WorkTime.data.Vid + ' Korrektur OK.',
                      variant: 'success',
                    },
                  },
                  {
                    timeout: 2500,
                  })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    CheckFilter(item) {
      let filterAddress = true;
      if(this.filterAddress != 0) {
        let split = this.filterAddress.split('-');
        if(item.PickupAddressIdentId != split[0] || item.DestinationAddressIdentId != split[1]) {
          filterAddress = false
        }
      }
      return (item.show == true && (this.filterCustomer == 0 || item.Customer.IdentId == this.filterCustomer)) && filterAddress
    },
    Background(vdata) {
      return {
        'background-color': vdata.OnlineStatus == 1 ? 'rgba(150,74,74,0.39)' : 'rgba(63,83,105,0.39)',
        padding: '1em',
        'background-size': '100%',
        'margin-bottom': '0.7em',
        'border-radius': '0.5em',
        'color': 'rgba(255,255,255,1)'
      }
      return {
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(' + this.icon.Condor + ')',
        'background-position': '0% 55%',
        'background-color': 'rgba(0,0,0,.1)',
        padding: '1em',
        'background-size': '100%',
        'margin-bottom': '0.7em',
        'border-radius': '0.3em'
      }
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    SetTempCheck() {
      this.TempCheckFilter = this.TempCheckFilter == 0 ? 1 : 0
      this.items.forEach((v, i) => {
        v.show = true
        if (this.TempCheckFilter == 1) {
          v.show = v.TempCheckTime != null ? true : false
        }

      })
    },
    HasBetaRights() {
      return this.$store.state.user.Rights.includes('R2')
    },
    FilterDriver(did) {
      if (did > 0 && this.DriverFilter == did) {
        this.DriverFilter = 0
      } else {
        this.DriverFilter = did
      }
      this.HasDriverTrip()
    },
    HasDriverTrip() {
      this.items.forEach((v, i) => {
        v.show = this.DriverFilter == 0 ? true : false
        v.Driver.forEach(d => {
          if (d.driverId == this.DriverFilter) {
            v.show = true
          }
        })
      })
    },
    DispositionDispatch() {
      this.$router.push({
        name: 'DispositionDispatch',
        params: { day: this.$route.params.day }
      })
    },
    innerHeight() {
      return window.innerHeight
    },
    userAgent() {
      return navigator.userAgent
    },
    CheckMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    IsVehicleDispoVehicle(veh) {

      Object.keys(this.popover.VehicleDistance.data.drivers)
          .forEach(d => {
            if (this.popover.VehicleDistance.data.drivers[d] == veh) {
              return true
            }
          })
      this.$nextTick(() => {

        return false
      })
    },
    HasUserEditRight() {
      return this.$store.state.user.Rights.includes('R420')
    },
    SaveDescription(event, item) {


      if (this.SaveDescriptionTimeout) {
        clearTimeout(this.SaveDescriptionTimeout)
      }
      this.SaveDescriptionTimeout = setTimeout(() => {
        this.$http.post('/disposition/save/voucher/description', JSON.stringify({
          Description1: this.Description[item.Vid].Description1,
          Description2: this.Description[item.Vid].Description2,
          VoucherId: item.Vid
        }))
            .then(resp => {
              if (resp.data.success) {

                event.target.style.background = 'rgba(0,255,0,0.1)'
                this.SaveDescriptionTimeout = setTimeout(() => {
                  event.target.style.background = null
                }, 1550)
              }
            })
            .catch(err => {
              console.error(err)
            })
      }, 1550)

      event.target.style.background = 'rgba(255,255,0,0.1)'

    },
    Cancel(v) {
      this.$swal({
        title: 'STORNIEREN',
        text: 'Möchten Sie diesen Voucher wirklich stornieren?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, stornieren!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.isConfirmed) {
              this.$http.post('/voucher/cancel', JSON.stringify(v.Vid))
                  .then(resp => {
                    if (resp.data.success) {
                      v.Canceled = true
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: 'Voucher wurde storniert.',
                          variant: 'success',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })

    },
    LoadObCalendar() {
      this.headerDrivers = []
      this.$http.get(`/disposition/ob/get/calendar/${this.$route.params.day}`)
          .then(resp => {
            resp.data.forEach(i => {
              this.headerDrivers.forEach(i2 => {
                if (i.sig == i2.Driver.DriverShortName) {
                  i2.Calendar += ' (' + i.status + ')'
                  i2.Variant = 'info'
                }
              })
            })
            this.items.forEach((v, i) => {
              v.show = false
              v.show = true
            })
          })
          .catch(err => {
            console.error(err)
          })

    },
    UndoCancel(v) {
      this.$http.post('/voucher/undocancel', JSON.stringify(v.Vid))
          .then(resp => {
            if (resp.data.success) {
              v.Canceled = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Voucher wurde enstorniert.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    ConfirmVoucher(item) {
      this.$http.post('/voucher/confirm', parseInt(item.Vid))
          .then(resp => {
            if (resp.data.success) {
              item.Confirmed = true
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Voucher wurde bestätigt.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    OpenVoucher(vid) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: vid }
      })
    },
    FormatTime(time) {
      return time.slice(0, 5)
    },
    OpenPdf() {
      let url = `/disposition/get/pdf/${this.$route.params.day}`
      this.$http.get(url, { responseType: 'blob' })
          .then(resp => {
            window.open(URL.createObjectURL(resp.data))

          })
          .catch(err => {
            console.error(err)
          })

    },

    SelectDriverPayment(driver, vid) {
      this.$http.post('disposition/set/driver/payment', JSON.stringify({
        Driver: driver,
        VoucherId: vid
      }))
          .then(resp => {
            if (resp.data.success) {
              //this.LoadList()
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Ok',
                      icon: 'CheckIcon',
                      text: 'V-ID ' + vid + ' Fahrer OK.',
                      variant: 'success',
                    },
                  },
                  {
                    timeout: 2500,
                  })
            } else {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: 'Es ist ein Fehler aufgetreten.',
                      variant: 'danger',
                    },
                  },
                  {
                    timeout: 10000,
                  })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },

    NextDay() {
      const result = new Date(this.$route.params.day)
      result.setDate(result.getDate() + 1)

      this.$router.push({
        name: 'Disposition',
        params: { day: result.getFullYear() + '-' + ('0' + (result.getMonth() + 1)).slice(-2) + '-' + ('0' + result.getDate()).slice(-2) }
      })
      this.LoadVehicleList()
      this.LoadDriverList()
      this.LoadObCalendar()
    },
    LastDay() {
      const result = new Date(this.$route.params.day)
      result.setDate(result.getDate() - 1)

      this.$router.push({
        name: 'Disposition',
        params: { day: result.getFullYear() + '-' + ('0' + (result.getMonth() + 1)).slice(-2) + '-' + ('0' + result.getDate()).slice(-2) }
      })
      this.LoadVehicleList()
      this.LoadDriverList()
      this.LoadObCalendar()
    },
    SelectDriver(drivers, vid, changeDriver) {
      if (this.HasUserEditRight()) {
        let found = -1
        drivers.forEach((value, i) => {
          if (value.driverId == changeDriver.driverId) {
            found = i
          }
        })
        if (found == -1) {
          drivers.push(changeDriver)
          this.headerDrivers.forEach(i2 => {
            if (changeDriver.driverId == i2.Driver.DId) {
              i2.TripCount++
            }
          })
        } else {
          drivers.splice(found, 1)
          this.headerDrivers.forEach(i2 => {
            if (changeDriver.driverId == i2.Driver.DId) {
              i2.TripCount--
            }
          })
        }

        this.$http.post('disposition/set/driver', JSON.stringify({
          Drivers: drivers,
          VoucherId: vid
        }))
            .then(resp => {
              if (resp.data.success) {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Ok',
                        icon: 'CheckIcon',
                        text: 'V-ID ' + vid + ' Fahrer OK.',
                        variant: 'success',
                      },
                    },
                    {
                      timeout: 2500,
                    })
              } else {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Fehler',
                        icon: 'CheckIcon',
                        text: 'Es ist ein Fehler aufgetreten.',
                        variant: 'danger',
                      },
                    },
                    {
                      timeout: 10000,
                    })
              }
            })
            .catch(err => {
              console.error(err)
            })
      } else {
        this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: 'Sie haben keine Berechtigung für diese Aktion.',
                variant: 'danger',
              },
            },
            {
              timeout: 5000,
            })
      }

    },
    LoadDriverList() {
      this.drivers = []
      this.$http.get(`/driver/list?propertys=DriverShortName,DId,Color1,Color2,NumberPlate&option=1`)
          .then(resp => {
            let list = []
            this.filterDrivers = []
            this.filterDrivers.push({
              text: 'Kein Fahrer filtern',
              value: 0,
            })
            resp.data.list.forEach(i => {
              i.Calendar = ''
              i.Variant = 'danger'
              this.headerDrivers.push(i)

              this.filterDrivers.push({
                text: i.Driver.DriverShortName,
                value: i.Driver.DId,
              })
              list.push({
                title: i.Driver.DriverShortName + '(' + (i.Vehicle != null ? i.Vehicle.NumberPlate : '') + ')',
                driverId: i.Driver.DId,
                Color1: i.Driver.Color1,
                Color2: i.Driver.Color2,
              })
            })
            this.drivers = Object.freeze(list)
            this.LoadList()

          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadVehicleList() {
      this.vehicleList = []
      this.$http.get(`/vehicle/list`)
          .then(resp => {
            resp.data.forEach(p => {
              this.vehicleList.push({
                value: p.VId,
                text: p.NumberPlate
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    GetVoucherImage(id) {
      if (id == 0) {
        return `<img src="${this.icon.Fly}" alt="Logo" width="32" style="filter: brightness(0) invert(1); transform: rotate(-75deg)" >`
      }

      if (id == 1) {
        return `<img src="${this.icon.MedicalTrip}" alt="Logo" width="32" style="filter: brightness(0) invert(1); transform: rotate(0deg)" >`
      }

      if (id == 2) {
        return `<img src="${this.icon.Transfer}" alt="Logo" width="32" style="filter: brightness(0) invert(1); transform: rotate(-75deg)" >`
      }

    },
    VoucherDraw(i, index = -1) {
      i.Driver = []
      for (const [Driver, Vehicle] of Object.entries(i.Drivers)) {
        this.drivers.forEach(dl => {
          if (dl.driverId == Driver) {
            const veh = ''

            this.vehicleList.forEach(veh => {
              if (veh.value == Vehicle) {
                i.Driver.push({
                  driverId: dl.driverId,
                  title: dl.title + (!dl.title.includes('(' + veh.text + ')') ? ' (' + veh.text + ')' : ''),
                  Color1: dl.Color1,
                  Color2: dl.Color2,

                })
                this.headerDrivers.forEach(i2 => {
                  if (Driver == i2.Driver.DId) {
                    i2.TripCount++
                  }
                })
              }
            })
          }
        })
      }
      let foundFilter = false
      this.filterCustomerOptions.forEach(fi => {
        if (fi.value == i.Customer.IdentId) {
          foundFilter = true
        }
      })
      if (!foundFilter) {
        this.filterCustomerOptions.push({
          text: '(' + i.Customer.CustomerNumber + ') ' + i.Customer.Name,
          value: i.Customer.IdentId
        })
      }

      i.show = true
      this.Description[i.Vid] = {
        Description1 : i.Description1,
        Description2 : i.Description2
      };

      if (index >= 0) {
        return i
      } else {
        this.items.push(i)
      }
    },
    LoadList() {
      this.items = []
      this.ReloadFilterCustomer()
      this.ReloadFilterAddress();
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/disposition/get/${this.$route.params.day}?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/disposition/get/${this.$route.params.day}/filter?filter=${this.filter}`
      }
      this.$http.get(url, { timeout: 10 * 60 * 1000 })
          .then(resp => {
            this.headerDrivers.forEach(i2 => {
              i2.TripCount = 0
            })

            resp.data.forEach(i => {
              this.VoucherDraw(i)
            })

          })
          .catch(err => {
            console.error(err)
          })

    },
    CallNumber(number) {
      console.log("ANGEKLICKT:", number);

  this.$http.get(`/phone/call?number=${encodeURIComponent(number)}`)
      .then(resp => {
        if (resp.data.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Anruf gestartet',
              icon: 'PhoneCallIcon',
              text: 'Dein Telefon wird jetzt angerufen.',
              variant: 'success',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Fehler',
              text: resp.data.error,
              variant: 'danger',
            },
          })
        }
      })
    },
  },
  
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';


.scrollable {
  height: 65vh; /* Höhe des scrollbaren Bereichs auf 70% der Bildschirmhöhe festlegen */
  overflow-y: auto; /* Sichtbarkeit der vertikalen Scrollbar aktivieren */
}

/* Styling der Scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

/* Styling des Scrollbar-Thumb */
::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 10px;
}

/* Styling des Scrollbar-Thumb beim Hovern */
::-webkit-scrollbar-thumb:hover {
  background-color: #666;
}
</style>
